import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/PaginatePublic.vue'
import { comma } from '@/components/mixins/comma.js';
import { auth } from '@/components/mixins/auth.js';
import io from "socket.io-client";
export const myGoodsBuy= {   
    mixins:[ auth,comma ],
    data(){
        return{
            itemlists:'',
            itemState:['배송완료(지급완료)','배송대기','승인대기','환불대기','환불완료','기타'],
            ckItemUse:false,
            currentItemId:0,
            selcomponent:'',            
            popdialog:false,   
            refundGoods:'',   
            isLoading:false,
            socket: io(this.$store.state.serverDomain + ":3000"),      
        }
    },
    components:{
        DisplayTime,
        Paginate,       
    },
    mounted()
    {
        this.getBuyItems();
    },
    computed:{
        itembuylists(){
            return this.$store.state.goods.goodsBuy;
        },
        
    },
    methods:{
        linkgoods(id)
        {
            this.$router.push('/m/item/pshopview/'+id);
        },
        async confirmRefund(){
            if(this.authCheck() !==true)
            {
                return
            }             
            const formData = {
                goodsBuyId:this.refundGoods.id,
                user_id:this.user.id,                       
            }
            try {
                const response = await this.$store.dispatch("goods/reqRefund", formData)
                console.log(response);
                this.socket.emit("newGoodsState");
                this.$flashMessage.show({
                    type: response.refund===false?"error":"info",
                    title: response.message,
                    message: response.message,
                });               
                this.popdialog = false;
            }catch(error){
                console.log(error);
            }
            
        }, 
        ckday(){
            //요일 체크해서 환불신청 가능한지 파악 월~목요일까지만 가능하게
            let d = (new Date()).getDay();
            // const week = new Array('일','월','화','수','목','금','토');
            // return week[d];
            let possibleRefund = false;
            if(d >= 1 && d <=4)
            {
                possibleRefund = true;        
            }
            return possibleRefund;
        },
        confirm(){
            this.ckItemUse = false;
        },
        popClose(){
          
            this.popdialog = false;

        },
        refund(current){            
            
            this.refundGoods = this.itembuylists.data.find((goodsbuy)=>goodsbuy.id === current);   
            this.popdialog = true;

        },
        async getBuyItems(pagenumber){
           this.isLoading = true;
            this.itemlists = '';
            const formData = {
                user_id:this.$store.getters.currentUser.id,  page:pagenumber?pagenumber:1
            }
            try {
                const response = await this.$store.dispatch("goods/getBuyGoods", formData)
                this.itemlists = response;
            }catch(error){
                console.log(error);
            }
            this.isLoading = false;
        },        
    }
}